import { render, staticRenderFns } from "./GramInflowOther.vue?vue&type=template&id=615ea203"
import script from "./GramInflowOther.vue?vue&type=script&lang=ts"
export * from "./GramInflowOther.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/observation/visit/gram-inflow.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fobservation%2Fvisit%2Fgram%2FGramInflowOther.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports